import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import Menu from '../../Images/menu.svg';

import './Navigation.css';

const Navigation = ({navigate,width,opacity}) => {
	const [ expand, setExpand ] = useState(false);

	const node = useRef();
	useEffect(()=>{
		function handleClick(e) {
			if(node.current) {
				if(!node.current.contains(e.target)){
					setExpand(false);
				}
			}
		}
		document.addEventListener('mousedown', handleClick, false);
		return () => {
			document.removeEventListener('mousedown', handleClick, false);
		}
	},[]);

	const url = window.location.pathname;

	let className = 'flexCenter navBar';
	if(opacity !== undefined) className = 'flexCenter navBarInvisible';
	if(width < 700){
		return(
			<div className={className} style={{zIndex:200}}>
				<div className='fullHeight flexHeightCenter flexRight' style={{width:width}}>
					<img src={Menu} alt='Menu' style={{height:30,padding:10}} className='pointer' onClick={()=>{setExpand(!expand)}} />
				</div>
				{expand === true
					? <div style={{position:'fixed',top:60,right:0,bottom:0,zIndex:20000011}}>
						<div style={{height:'100%',background:'black',width:260,borderTop:'1px solid rgba(255,255,255,0.2)'}} ref={node}>
							{url === '/'
								? <div className='navItem2 flexHeightCenter'>Andy Marsh</div>
								: <div className='navItem2 flexHeightCenter hoverOpacityUp' onClick={()=>{navigate('/')}}>Andy Marsh</div>
							}
							{url === '/about'
								? <div className='navItem2 flexHeightCenter'>About</div>
								: <div className='navItem2 flexHeightCenter hoverOpacityUp' onClick={()=>{navigate('/about')}}>About</div>
							}
							{url === '/film'
								? <div className='navItem2 flexHeightCenter'>Film scoring</div>
								: <div className='navItem2 flexHeightCenter hoverOpacityUp' onClick={()=>{navigate('/film')}}>Film scoring</div>
							}
							{url === '/placements'
								? <div className='navItem2 flexHeightCenter'>Song writing</div>
								: <div className='navItem2 flexHeightCenter hoverOpacityUp' onClick={()=>{navigate('/placements')}}>Song writing</div>
							}
							{url === '/musical'
								? <div className='navItem2 flexHeightCenter'>Musical</div>
								: <div className='navItem2 flexHeightCenter hoverOpacityUp' onClick={()=>{navigate('/musical')}}>Musical</div>
							}
							{url === '/contact'
								? <div className='navItem2 flexHeightCenter'>Contact</div>
								: <div className='navItem2 flexHeightCenter hoverOpacityUp' onClick={()=>{navigate('/contact')}}>Contact</div>
							}
						</div>
					</div>
					: null
				}
			</div>
		)
	}
	return(
		<div className={className}>
			<div className='fullHeight flexHeightCenter' style={{width:width}}>
				{/*<div className='navItem flexCenter' >Home</div>*/}
				{url === '/'
					? <Link className='navItem navSelected flexCenter' style={{paddingLeft:0}} to='/'>Andy Marsh</Link>
					: <Link className='navItem flexCenter hoverOpacityUp' style={{paddingLeft:0}} to='/'>Andy Marsh</Link>
				}
				{url === '/about'
					? <Link className='navItem navSelected flexCenter' to='/about'>About</Link>
					: <Link className='navItem flexCenter hoverOpacityUp' to='/about'>About</Link>
				}
				{/*<div className='navItem flexCenter' >Film scoring</div>*/}
				{url === '/film'
					? <Link className='navItem navSelected flexCenter' style={{}} to='/film'>Film scoring</Link>
					: <Link className='navItem flexCenter hoverOpacityUp' to='/film'>Film scoring</Link>
				}
				{url === '/placements'
					? <Link className='navItem navSelected flexCenter' style={{}} to='/placements'>Song writing</Link>
					: <Link className='navItem flexCenter hoverOpacityUp' to='/placements'>Song writing</Link>
				}
				{url === '/musical'
					? <Link className='navItem navSelected flexCenter' style={{}} to='/musical'>Musical</Link>
					: <Link className='navItem flexCenter hoverOpacityUp' to='/musical'>Musical</Link>
				}
				{url === '/contact'
					? <Link className='navItem navSelected flexCenter' style={{}} to='/contact'>Contact</Link>
					: <Link className='navItem flexCenter hoverOpacityUp' to='/contact'>Contact</Link>
				}
			</div>
		</div>
	)
}

export default Navigation;